import React, { Component } from 'react';
import { translate } from 'react-translate'
import { Link } from 'react-router-dom';
import Textblock from '../Components/Textblock';
import MassInfo from '../Components/MassInfo';
import PrayerInfo from '../Components/PrayerInfo';
import FullPageText from '../Components/FullPageText';
import ResponsiveImage from '../Components/ResponsiveImage';
import Iframe from 'react-iframe';


import ParteSavio from '../Images/savio/parte-savio.png';
import Savio1 from '../Images/savio/savio1.jpg';
import Savio2 from '../Images/savio/savio2.jpg';
import Savio3 from '../Images/savio/savio3.jpg';
import Savio4 from '../Images/savio/savio4.jpg';
import Savio5 from '../Images/savio/savio5.jpg';
import Savio6 from '../Images/savio/savio6.jpg';
import Savio7 from '../Images/savio/savio7.jpg';

import Savio9 from '../Images/savio/savio9.jpg';
import Savio10 from '../Images/savio/savio10.jpg';
import Savio11 from '../Images/savio/savio11.jpg';
import Savio12 from '../Images/savio/savio12.jpg';
import Savio13 from '../Images/savio/savio13.jpg';
import Savio14 from '../Images/savio/savio14.jpg';
import Savio15 from '../Images/savio/savio15.jpg';
import Savio16 from '../Images/savio/savio16.jpg';
import Savio17 from '../Images/savio/savio17.jpg';
import Savio18 from '../Images/savio/savio18.jpg';
import Savio19 from '../Images/savio/savio19.jpg';
import Savio20 from '../Images/savio/savio20.jpg';
import Savio21 from '../Images/savio/savio21.jpg';
import Savio22 from '../Images/savio/savio22.jpg';
import Savio23 from '../Images/savio/savio23.jpg';
import Savio24 from '../Images/savio/savio24.jpg';
import Savio25 from '../Images/savio/savio25.jpg';
import Savio26 from '../Images/savio/savio26.jpg';
import Savio27 from '../Images/savio/savio27.jpg';
import Savio28 from '../Images/savio/savio28.jpg';
import Savio29 from '../Images/savio/savio29.jpg';

import Savio30 from '../Images/savio/savio30.jpg';
import Savio31 from '../Images/savio/savio31.jpg';
import Savio32 from '../Images/savio/savio32.jpg';
import Savio33 from '../Images/savio/savio33.jpg';
import Savio34 from '../Images/savio/savio34.jpg';
import Savio35 from '../Images/savio/savio35.jpg';
import Savio36 from '../Images/savio/savio36.jpg';

import SavioRozhovor from '../Images/savio/savio-rozhovor.jpg';

class Savio extends Component {
    render() {
        return (
                <div className="main-content">
                    <div className="op-container animatedParent animateOnce">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-6">
                            <h1 className="main-title ">
                                P. Savio Řičica OP
                            </h1>
                            {/* <div className="main-perex animated fadeInRightShort">
                                <p>
                                    ...nyní užívají mnišky řádu bratří kazatelů – řeholní společenství v rámci římskokatolické církve. Jsou také
                                    známy jako dominikánky podle sv. Dominika Guzmána.
                                    První dům dominikánských mnišek založil svatý Dominik v Prouille ve Francii r. 1206.
                                </p> 
                                <div className="text-center star-container">
                                    <div className="star"></div>
                                </div>
                            </div> */}
                        </div>
                        <div className="clearfix"></div>
                    </div>
                </div>

                    <ResponsiveImage img={ParteSavio} title="parte Savio" />
                    <div className="history-photo-gallery margin-top-50 ">
                        <img src={Savio1} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio1} data-fancybox-group="all" />
                        <img src={Savio2} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio2} data-fancybox-group="all" />
                        <img src={Savio3} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio3} data-fancybox-group="all" />
                        <img src={Savio4} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio4} data-fancybox-group="all" />
                        <img src={Savio5} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio5} data-fancybox-group="all" />
                        <img src={Savio6} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio6} data-fancybox-group="all" />
                        <img src={Savio7} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio7} data-fancybox-group="all" />
                        <img src={Savio9} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio9} data-fancybox-group="all" />
                        <img src={Savio10} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio10} data-fancybox-group="all" />
                        <img src={Savio11} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio11} data-fancybox-group="all" />
                        <img src={Savio12} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio12} data-fancybox-group="all" />
                        <img src={Savio13} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio13} data-fancybox-group="all" />
                        <img src={Savio14} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio14} data-fancybox-group="all" />
                        <img src={Savio15} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio15} data-fancybox-group="all" />
                        <img src={Savio16} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio16} data-fancybox-group="all" />
                        <img src={Savio17} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio17} data-fancybox-group="all" />
                        <img src={Savio18} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio18} data-fancybox-group="all" />
                        <img src={Savio19} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio19} data-fancybox-group="all" />
                        <img src={Savio20} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio20} data-fancybox-group="all" />
                        <img src={Savio21} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio21} data-fancybox-group="all" />
                        <img src={Savio22} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio22} data-fancybox-group="all" />
                        <img src={Savio23} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio23} data-fancybox-group="all" />
                        <img src={Savio24} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio24} data-fancybox-group="all" />
                        <img src={Savio25} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio25} data-fancybox-group="all" />
                        <img src={Savio26} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio26} data-fancybox-group="all" />
                        <img src={Savio27} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio27} data-fancybox-group="all" />
                        <img src={Savio28} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio28} data-fancybox-group="all" />
                        <img src={Savio29} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio29} data-fancybox-group="all" />
                        <img src={Savio30} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio30} data-fancybox-group="all" />
                        <img src={Savio31} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio31} data-fancybox-group="all" />
                        <img src={Savio32} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio32} data-fancybox-group="all" />
                        <img src={Savio33} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio33} data-fancybox-group="all" />
                        <img src={Savio34} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio34} data-fancybox-group="all" />
                        <img src={Savio35} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio35} data-fancybox-group="all" />
                        <img src={Savio36} alt="Savio Řičica" data-caption="Savio Řičica" data-fancybox="gallery" href={Savio36} data-fancybox-group="all" />
                    </div>
                    <ResponsiveImage img={SavioRozhovor} title="rozhovor" />
                    <div className='margin-top-50'>
                        <div className="video-iframe-wrapper-container">
                            <div className="video-iframe-wrapper">
                                <Iframe width="100%" url="https://www.youtube.com/embed/F3elWr1jc7Y" frameBorder="0" allowFullScreen></Iframe>
                            </div>
                        </div>
                    </div>
                    <div className='margin-top-50 margin-bottom-50'>
                        <div className="video-iframe-wrapper-container">
                            <div className="video-iframe-wrapper">
                                <Iframe width="100%" url="https://www.youtube.com/embed/DJ2nbL3TCp0" frameBorder="0" allowFullScreen></Iframe>
                            </div>
                        </div>
                    </div>
                </div>
        );
    }
}

export default translate("Savio")(Savio);